/* V2 */
import * as React from "react";
import {isEmpty as _isEmpty} from "lodash";
import * as $ from "jquery";
import { ORION_IMG_URL } from "../utils/AppConstants";
import AppUtils from "../utils/AppUtils";

export interface CollapsibleCardViewProps {
  titleComponent: any;
  children?: any;
  actionName?: string;
  actionCallback?: () => any;
  primaryActionName?: string;
  primaryActionCallback?: () => any;
  showActionButtons?: boolean;
  cardViewCustomStyle?: any;
  showCollapseButton?: boolean;
  responseData?: any;
  collapsedTextPlaceholderForMobile?: string | undefined;
}

const toggleCardView = function(evt: any): void {
    let collapsibleCard = $(evt.target).closest(".collapsible-card");
    collapsibleCard.find(".collapsible-button").toggleClass("rotated");
    collapsibleCard.find(".collapsible-container").slideToggle();
    evt.stopPropagation();
};


const CollapsibleCardView: React.StatelessComponent<CollapsibleCardViewProps> = (props: CollapsibleCardViewProps) => {
    const [isCollapsed, setIsToggled] = React.useState(true); // only for mobile view

    const getShouldShowCollapsedAddBtnView = () => {
      return AppUtils.getIsMobile() && isCollapsed && props.collapsedTextPlaceholderForMobile;
    }

    const onCollapseClick = (event: React.SyntheticEvent) => {
      setIsToggled(!isCollapsed);
      toggleCardView(event);
    };

    let cardWrapperCls = _isEmpty(props.primaryActionName) ? "" : "with-primary-action";
    return (
      <div className={cardWrapperCls}>
        <div className="card-view collapsible-card">
          {props.titleComponent !== "" && (
            <div className="header-row">
              {
                <div className="card-title in-blk mid-align brandon-bold">
                  {props.titleComponent}
                </div>
              }
              {props.showCollapseButton !== undefined &&
                props.showCollapseButton && !getShouldShowCollapsedAddBtnView() && (
                  <div
                    className="collapsible-button in-blk mid-align pull-right"
                    onClick={onCollapseClick}
                  >
                  <img src={ORION_IMG_URL + "icons/down-arrow.svg"} />
                  </div>
                )}
              {props.primaryActionName && props.showActionButtons && (
                <div
                  className="card-primary-action card-action pull-right"
                  onClick={props.primaryActionCallback}
                >
                  {props.primaryActionName}
                </div>
              )}
              {props.actionName && props.showActionButtons && (
                <div
                  className="card-action pull-right"
                  onClick={props.actionCallback}
                >
                  {props.actionName}
                </div>
              )}
            </div>
          )}
          <div
            className={`collapsible-container ${getShouldShowCollapsedAddBtnView() &&
              "collapsible-container-hidden"}`}
          >
            {props.children}
          </div>
          {getShouldShowCollapsedAddBtnView() && (
            <div className="add-item-row">
              <span className="add-item-click-msg">Click on the add button to add a {props.collapsedTextPlaceholderForMobile}</span>
              <button onClick={onCollapseClick} className="cf-btn-add">Add <span className="cf-btn-add-icon">+</span></button>
            </div>
          )}
        </div>
      </div>
    );
};

export default CollapsibleCardView;